"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.History=exports.Amount=void 0;const History=exports.History=_styledComponents.default.div`
max-height:400px;
overflow-y:scroll;
scroll-behavior: smooth;

::-webkit-scrollbar-thumb {
    background-color: #888; /* Color of the scrollbar thumb */
    border-radius: 4px; /* Rounded corners for the scrollbar thumb */
  }

  /* Force scrollbar thumb to always be visible */
  &::after {
    content: '';
    display: block;
    margin-top: -2px; /* Negative margin to avoid affecting layout */
}
.history{
    display: flex;
    padding: 4px 16px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background-color:#F1F0EE;
}

.history > div {
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 18px;
color:#535250;
}

.account{
    display: flex;
padding: 12px 16px;
align-items: center;
align-self: stretch;
gap:10px

.detail+ div{
    color:  #2A2928;
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
text-align: right;
font-feature-settings: 'liga' off, 'calt' off;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 18px;
}

.detail {
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    flex: 1 0 0;
    line-height: 0;
}

.detail>p:nth-child(1){
    display: flex;
width: 247px;
flex-direction: column;
justify-content: center;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 10px; 
color:#2A2928;
margin-bottom: -5px;

}

.detail>p:nth-child(2){
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    color:#2A2928;
    margin-left:4px;
    background: #FAF9F8;
    }

    .orderNumber{
    font-weight:600;
    }
    p{
        margin-top: 10px;
        margin-bottom: 10px;
    }
}
`,Amount=exports.Amount=_styledComponents.default.div`
    color: ${a=>"SALE"===a?.transactionType?"red":"black"};
`;